import styled from 'styled-components';

import { mediaConfined, mediaWide } from '@xingternal/layout-tokens';
import { Tag as TagComponent } from '@xingternal/tag';
import { spaceL, spaceM, spaceS, spaceXL } from '@xingternal/tokens';

export const Tag = styled(TagComponent)`
  display: inline-flex;
  margin-bottom: ${spaceM};
  margin-right: ${spaceS};
`;

export const Container = styled.section`
  @media ${mediaConfined} {
    margin-top: ${spaceL};
  }

  @media ${mediaWide} {
    margin-top: ${spaceXL};
  }
`;
